import { CurrencyEnum } from "src/client";
import { toOptions } from "src/utils/toOptions";

import { DecimalSeparatorEnum } from "./client/models/DecimalSeparatorEnum";

export const NEW_ID = "new";

export const NO_GROUPING_NAME = "No group";
export const NO_GROUPING_ID = "null";

export const CURRENCY_LABEL_BY_CODE = {
  [CurrencyEnum.ALL]: "Albania Lek (L)",
  [CurrencyEnum.AFN]: "Afghanistan Afghani (؋)",
  [CurrencyEnum.ARS]: "Argentina Peso ($) ",
  [CurrencyEnum.AWG]: "Aruba Guilder (ƒ)",
  [CurrencyEnum.AUD]: "Australia Dollar ($)",
  [CurrencyEnum.AZN]: "Azerbaijan New Manat (₼)",
  [CurrencyEnum.BSD]: "Bahamas Dollar ($) ",
  [CurrencyEnum.BBD]: "Barbados Dollar ($) ",
  [CurrencyEnum.BDT]: "Bangladeshi taka (৳)",
  [CurrencyEnum.BYR]: "Belarus Ruble (Br)",
  [CurrencyEnum.BZD]: "Belize Dollar ($) ",
  [CurrencyEnum.BMD]: "Bermuda Dollar ($) ",
  [CurrencyEnum.BOB]: "Bolivia Boliviano (Bs.)",
  [CurrencyEnum.BAM]: "Bosnia and Herzegovina Convertible Marka (KM)",
  [CurrencyEnum.BWP]: "Botswana Pula (P)",
  [CurrencyEnum.BGN]: "Bulgaria Lev (лв)",
  [CurrencyEnum.BRL]: "Brazil Real (R$)",
  [CurrencyEnum.BND]: "Brunei Darussalam Dollar ($) ",
  [CurrencyEnum.KHR]: "Cambodia Riel (៛)",
  [CurrencyEnum.CAD]: "Canada Dollar ($) ",
  [CurrencyEnum.KYD]: "Cayman Islands Dollar ($) ",
  [CurrencyEnum.CLP]: "Chile Peso ($) ",
  [CurrencyEnum.CNY]: "China Yuan Renminbi (¥)",
  [CurrencyEnum.COP]: "Colombia Peso ($) ",
  [CurrencyEnum.CRC]: "Costa Rica Colon (₡)",
  [CurrencyEnum.HRK]: "Croatia Kuna (kn)",
  [CurrencyEnum.CUP]: "Cuba Peso (₱)",
  [CurrencyEnum.CZK]: "Czech Republic Koruna (Kč)",
  [CurrencyEnum.DKK]: "Denmark Krone (kr)",
  [CurrencyEnum.DOP]: "Dominican Republic Peso (RD$)",
  [CurrencyEnum.XCD]: "East Caribbean Dollar ($) ",
  [CurrencyEnum.EGP]: "Egypt Pound (E£)",
  [CurrencyEnum.SVC]: "El Salvador Colon (₡)",
  [CurrencyEnum.EEK]: "Estonia Kroon (kr)",
  [CurrencyEnum.EUR]: "Euro Member Countries (€)",
  [CurrencyEnum.FKP]: "Falkland Islands (Malvinas) Pound (£)",
  [CurrencyEnum.FJD]: "Fiji Dollar ($) ",
  [CurrencyEnum.GHC]: "Ghana Cedis (₵)",
  [CurrencyEnum.GIP]: "Gibraltar Pound (£)",
  [CurrencyEnum.GTQ]: "Guatemala Quetzal (Q)",
  [CurrencyEnum.GGP]: "Guernsey Pound (£)",
  [CurrencyEnum.GYD]: "Guyana Dollar ($) ",
  [CurrencyEnum.HNL]: "Honduras Lempira (L)",
  [CurrencyEnum.HKD]: "Hong Kong Dollar ($) ",
  [CurrencyEnum.HUF]: "Hungary Forint (Ft)",
  [CurrencyEnum.ISK]: "Iceland Krona (kr)",
  [CurrencyEnum.INR]: "India Rupee (₹)",
  [CurrencyEnum.IDR]: "Indonesia Rupiah (Rp)",
  [CurrencyEnum.IRR]: "Iran Rial (﷼)",
  [CurrencyEnum.IMP]: "Isle of Man Pound (£)",
  [CurrencyEnum.ILS]: "Israel Shekel (₪)",
  [CurrencyEnum.JMD]: "Jamaica Dollar (J$)",
  [CurrencyEnum.JPY]: "Japan Yen (¥)",
  [CurrencyEnum.JEP]: "Jersey Pound (£)",
  [CurrencyEnum.KZT]: "Kazakhstan Tenge (₸)",
  [CurrencyEnum.KPW]: "Korea (North) Won (₩)",
  [CurrencyEnum.KRW]: "Korea (South) Won (₩)",
  [CurrencyEnum.KGS]: "Kyrgyzstan Som (сом)",
  [CurrencyEnum.LAK]: "Laos Kip (₭)",
  [CurrencyEnum.LVL]: "Latvia Lat (Ls)",
  [CurrencyEnum.LBP]: "Lebanon Pound (ل.ل)",
  [CurrencyEnum.LRD]: "Liberia Dollar ($) ",
  [CurrencyEnum.LTL]: "Lithuania Litas (Lt)",
  [CurrencyEnum.MKD]: "Macedonia Denar (ден)",
  [CurrencyEnum.MYR]: "Malaysia Ringgit (RM)",
  [CurrencyEnum.MUR]: "Mauritius Rupee (₨)",
  [CurrencyEnum.MXN]: "Mexico Peso ($) ",
  [CurrencyEnum.MNT]: "Mongolia Tughrik (₮)",
  [CurrencyEnum.MZN]: "Mozambique Metical (MT)",
  [CurrencyEnum.NAD]: "Namibia Dollar ($) ",
  [CurrencyEnum.NPR]: "Nepal Rupee (₨)",
  [CurrencyEnum.ANG]: "Netherlands Antilles Guilder (ƒ)",
  [CurrencyEnum.NZD]: "New Zealand Dollar ($) ",
  [CurrencyEnum.NIO]: "Nicaragua Cordoba (C$)",
  [CurrencyEnum.NGN]: "Nigeria Naira (₦)",
  [CurrencyEnum.NOK]: "Norway Krone (kr)",
  [CurrencyEnum.OMR]: "Oman Rial (ر.ع.)",
  [CurrencyEnum.PKR]: "Pakistan Rupee (₨)",
  [CurrencyEnum.PAB]: "Panama Balboa (B/.)",
  [CurrencyEnum.PYG]: "Paraguay Guarani (₲)",
  [CurrencyEnum.PEN]: "Peru Nuevo Sol (S/.)",
  [CurrencyEnum.PHP]: "Philippines Peso (₱)",
  [CurrencyEnum.PLN]: "Poland Zloty (zł)",
  [CurrencyEnum.QAR]: "Qatar Riyal (ر.ق)",
  [CurrencyEnum.RON]: "Romania New Leu (lei)",
  [CurrencyEnum.RUB]: "Russia Ruble (₽)",
  [CurrencyEnum.SHP]: "Saint Helena Pound (£)",
  [CurrencyEnum.SAR]: "Saudi Arabia Riyal (ر.س)",
  [CurrencyEnum.RSD]: "Serbia Dinar (дин.)",
  [CurrencyEnum.SCR]: "Seychelles Rupee (₨)",
  [CurrencyEnum.SGD]: "Singapore Dollar ($) ",
  [CurrencyEnum.SBD]: "Solomon Islands Dollar ($) ",
  [CurrencyEnum.SOS]: "Somalia Shilling (Sh)",
  [CurrencyEnum.ZAR]: "South Africa Rand (R)",
  [CurrencyEnum.LKR]: "Sri Lanka Rupee (₨)",
  [CurrencyEnum.SEK]: "Sweden Krona (kr)",
  [CurrencyEnum.CHF]: "Switzerland Franc (CHF)",
  [CurrencyEnum.SRD]: "Suriname Dollar ($) ",
  [CurrencyEnum.SYP]: "Syria Pound (£)",
  [CurrencyEnum.TWD]: "Taiwan New Dollar (NT$)",
  [CurrencyEnum.THB]: "Thailand Baht (฿)",
  [CurrencyEnum.TTD]: "Trinidad and Tobago Dollar (TT$)",
  [CurrencyEnum.TRY]: "Turkey Lira (₺)",
  [CurrencyEnum.TVD]: "Tuvalu Dollar ($) ",
  [CurrencyEnum.UAH]: "Ukraine Hryvnia (₴)",
  [CurrencyEnum.AED]: "United Arab Emirates Dirham (د.إ)",
  [CurrencyEnum.GBP]: "United Kingdom Pound (£)",
  [CurrencyEnum.USD]: "United States Dollar ($)",
  [CurrencyEnum.UYU]: "Uruguay Peso ($U)",
  [CurrencyEnum.UZS]: "Uzbekistan Som (лв)",
  [CurrencyEnum.VEF]: "Venezuela Bolívar (Bs.)",
  [CurrencyEnum.VND]: "Viet Nam Dong (₫)",
  [CurrencyEnum.YER]: "Yemen Rial (﷼)",
  [CurrencyEnum.ZWD]: "Zimbabwe Dollar (Z$)",
};

export const CURRENCY_OPTIONS = toOptions(CURRENCY_LABEL_BY_CODE, false);

export const CURRENCY_SYMBOL_BY_CODE = {
  [CurrencyEnum.ALL]: "L",
  [CurrencyEnum.AFN]: "؋",
  [CurrencyEnum.ARS]: "$",
  [CurrencyEnum.AWG]: "ƒ",
  [CurrencyEnum.AUD]: "$",
  [CurrencyEnum.AZN]: "₼",
  [CurrencyEnum.BSD]: "$",
  [CurrencyEnum.BBD]: "$",
  [CurrencyEnum.BDT]: "৳",
  [CurrencyEnum.BYR]: "Br",
  [CurrencyEnum.BZD]: "$",
  [CurrencyEnum.BMD]: "$",
  [CurrencyEnum.BOB]: "Bs.",
  [CurrencyEnum.BAM]: "KM",
  [CurrencyEnum.BWP]: "P",
  [CurrencyEnum.BGN]: "лв",
  [CurrencyEnum.BRL]: "R$",
  [CurrencyEnum.BND]: "$",
  [CurrencyEnum.KHR]: "៛",
  [CurrencyEnum.CAD]: "$",
  [CurrencyEnum.KYD]: "$",
  [CurrencyEnum.CLP]: "$",
  [CurrencyEnum.CNY]: "¥",
  [CurrencyEnum.COP]: "$",
  [CurrencyEnum.CRC]: "₡",
  [CurrencyEnum.HRK]: "kn",
  [CurrencyEnum.CUP]: "₱",
  [CurrencyEnum.CZK]: "Kč",
  [CurrencyEnum.DKK]: "kr",
  [CurrencyEnum.DOP]: "RD$",
  [CurrencyEnum.XCD]: "$",
  [CurrencyEnum.EGP]: "E£",
  [CurrencyEnum.SVC]: "₡",
  [CurrencyEnum.EEK]: "kr",
  [CurrencyEnum.EUR]: "€",
  [CurrencyEnum.FKP]: "£",
  [CurrencyEnum.FJD]: "$",
  [CurrencyEnum.GHC]: "₵",
  [CurrencyEnum.GIP]: "£",
  [CurrencyEnum.GTQ]: "Q",
  [CurrencyEnum.GGP]: "£",
  [CurrencyEnum.GYD]: "$",
  [CurrencyEnum.HNL]: "L",
  [CurrencyEnum.HKD]: "$",
  [CurrencyEnum.HUF]: "Ft",
  [CurrencyEnum.ISK]: "kr",
  [CurrencyEnum.INR]: "₹",
  [CurrencyEnum.IDR]: "Rp",
  [CurrencyEnum.IRR]: "﷼",
  [CurrencyEnum.IMP]: "£",
  [CurrencyEnum.ILS]: "₪",
  [CurrencyEnum.JMD]: "J$",
  [CurrencyEnum.JPY]: "¥",
  [CurrencyEnum.JEP]: "£",
  [CurrencyEnum.KZT]: "₸",
  [CurrencyEnum.KPW]: "₩",
  [CurrencyEnum.KRW]: "₩",
  [CurrencyEnum.KGS]: "сом",
  [CurrencyEnum.LAK]: "₭",
  [CurrencyEnum.LVL]: "Ls",
  [CurrencyEnum.LBP]: "ل.ل",
  [CurrencyEnum.LRD]: "$",
  [CurrencyEnum.LTL]: "Lt",
  [CurrencyEnum.MKD]: "ден",
  [CurrencyEnum.MYR]: "RM",
  [CurrencyEnum.MUR]: "₨",
  [CurrencyEnum.MXN]: "$",
  [CurrencyEnum.MNT]: "₮",
  [CurrencyEnum.MZN]: "MT",
  [CurrencyEnum.NAD]: "$",
  [CurrencyEnum.NPR]: "₨",
  [CurrencyEnum.ANG]: "ƒ",
  [CurrencyEnum.NZD]: "$",
  [CurrencyEnum.NIO]: "C$",
  [CurrencyEnum.NGN]: "₦",
  [CurrencyEnum.NOK]: "kr",
  [CurrencyEnum.OMR]: "ر.ع.",
  [CurrencyEnum.PKR]: "₨",
  [CurrencyEnum.PAB]: "B/.",
  [CurrencyEnum.PYG]: "₲",
  [CurrencyEnum.PEN]: "S/.",
  [CurrencyEnum.PHP]: "₱",
  [CurrencyEnum.PLN]: "zł",
  [CurrencyEnum.QAR]: "ر.ق",
  [CurrencyEnum.RON]: "lei",
  [CurrencyEnum.RUB]: "₽",
  [CurrencyEnum.SHP]: "£",
  [CurrencyEnum.SAR]: "ر.س",
  [CurrencyEnum.RSD]: "дин.",
  [CurrencyEnum.SCR]: "₨",
  [CurrencyEnum.SGD]: "$",
  [CurrencyEnum.SBD]: "$",
  [CurrencyEnum.SOS]: "Sh",
  [CurrencyEnum.ZAR]: "R",
  [CurrencyEnum.LKR]: "₨",
  [CurrencyEnum.SEK]: "kr",
  [CurrencyEnum.CHF]: "CHF",
  [CurrencyEnum.SRD]: "$",
  [CurrencyEnum.SYP]: "£",
  [CurrencyEnum.TWD]: "NT$",
  [CurrencyEnum.THB]: "฿",
  [CurrencyEnum.TTD]: "TT$",
  [CurrencyEnum.TRY]: "₺",
  [CurrencyEnum.TVD]: "$",
  [CurrencyEnum.UAH]: "₴",
  [CurrencyEnum.AED]: "د.إ",
  [CurrencyEnum.GBP]: "£",
  [CurrencyEnum.USD]: "$",
  [CurrencyEnum.UYU]: "$U",
  [CurrencyEnum.UZS]: "лв",
  [CurrencyEnum.VEF]: "Bs.",
  [CurrencyEnum.VND]: "₫",
  [CurrencyEnum.YER]: "﷼",
  [CurrencyEnum.ZWD]: "Z$",
};

export const LABEL_BY_DECIMAL_SEPARATOR = {
  [DecimalSeparatorEnum.PERIOD]: "Period",
  [DecimalSeparatorEnum.COMMA]: "Comma",
};

export const DECIMAL_SEPARATOR_OPTIONS = toOptions(
  LABEL_BY_DECIMAL_SEPARATOR,
  false
);
